__turbopack_context__.v({
  "card": "style-module-scss-module__wy41kq__card",
  "cards": "style-module-scss-module__wy41kq__cards",
  "label": "style-module-scss-module__wy41kq__label",
  "positions": "style-module-scss-module__wy41kq__positions",
  "section": "style-module-scss-module__wy41kq__section",
  "title": "style-module-scss-module__wy41kq__title",
});
